<template>
  <div>
    <UiBtn
      class="notification-header__btn"
      :active="isDropdownOpen.messages"
      color="gray"
      icon="header/notification"
      :size="{ default: 's', 'mobile-md': 'm', 'tablet-album': 'l' }"
      @click="toggleDropdown('messages')"
    >
      <span v-show="get_newUserMessagesLength" class="notification-header__count" />
    </UiBtn>
  </div>
</template>
<script>
import ClickOutside from 'vue-click-outside'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Notification',
  directives: { ClickOutside },
  computed: {
    ...mapGetters('base', ['isDropdownOpen']),
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('userMessages', ['get_newUserMessagesLength']),
  },
  methods: {
    ...mapActions('base', ['toggleDropdown']),
  },
}
</script>

<style lang="scss" scoped src="./style.scss"></style>
